import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { Filter, FilterOperation } from "src/app/core/jsonapi/filter";
import { FilterBuilder } from "src/app/core/jsonapi/filters-builder";
import { IParamsCollection } from "src/app/core/jsonapi/interfaces/params-collection";
import { Service } from "src/app/core/jsonapi/service";
import { CaseStateCaseMode } from "../_types/case-state-case-mode";

@Injectable({
    providedIn: 'root',
})
export class CaseStateCaseModeService extends Service<CaseStateCaseMode> {
    public override type = 'caseStateCaseModes';
    public override url = 'attendance/caseStateCaseModes';

    /** Ids de los modos de expediente relacionados con un estado. */
    public async loadModeIdsFor(caseStateId: string): Promise<string[]> {
        let response = await firstValueFrom(this.all(this.paramsFor(caseStateId)));
        return response.data
            .map((relation: CaseStateCaseMode) => relation.caseModeId)
            .filter((id: string | undefined) => !!id) as string[];
    }

    /**
     * Deja el estado relacionado exactamente con los modos indicados: borra las relaciones que
     * tenga e inserta las nuevas. El borrado es logico, asi que las filas viejas quedan con
     * Deleted = 1 y el indice unico de la tabla las ignora.
     */
    public async replaceForCaseState(caseStateId: string, caseModeIds: string[]): Promise<void> {
        let existing = await firstValueFrom(this.all(this.paramsFor(caseStateId)));
        for (const relation of existing.data) {
            await firstValueFrom(this.delete(relation.id));
        }
        for (const caseModeId of caseModeIds) {
            let relation = new CaseStateCaseMode();
            relation.caseStateId = caseStateId;
            relation.caseModeId = caseModeId;
            await firstValueFrom(this.save(relation));
        }
    }

    private paramsFor(caseStateId: string): IParamsCollection {
        return {
            filter: FilterBuilder.fromObject({
                caseStateId: new Filter(FilterOperation.equals, 'caseStateId', '', caseStateId)
            }).build(),
            page: { number: 1, size: 200 }
        };
    }
}
